import Vue from "vue";
import App from "./App.vue";
import "../../../registerServiceWorker";
import router from "../../../router";
import store from "./store.js";
import "babel-polyfill";

// import Vant from "vant";
// import "vant/lib/index.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { _initVConsole } from "../../../assets/js/util";
import Common from "../../../assets/js/common";
import "./common.less";

// 复制插件
var VueClipboard = require("vue-clipboard2");

Vue.config.productionTip = false;
// Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.prototype.$common = Common;

// 设置标题
router.beforeEach((to, from, next) => {
  // console.log("to,from,to,from", to.fullPath, from.fullPath);
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

_initVConsole();
